var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-icon',{attrs:{"size":"25"}},[_c('FullScreen',{on:{"click":_vm.click}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }